import cn from 'classnames'
import React from 'react'

import CartSubContent from '../Cart/CartSubContent'
import { HtmlContentViewer } from '../HtmlContentViewer/HtmlContentViewer'

interface ShortDescItemProps {
  shortDescription: string
}

export const ShortDescItem: React.FC<ShortDescItemProps> = ({ shortDescription = '' }) => {
  return (
    <CartSubContent className="html-show flex flex-col px-[1.875rem] mb-[2.0rem]">
      {shortDescription && (
        <div className="value-proposition">
          <HtmlContentViewer className={cn('body-des-html')} html={shortDescription} />
        </div>
      )}
    </CartSubContent>
  )
}
